import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  IBasicButtonContentProps,
  IBasicButtonLoaderProps,
  IBasicButtonProps,
} from "./types";

export const StyledBasicButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== "round" && prop !== "uppercase" && prop !== "isLoading",
})<IBasicButtonProps & { isLoading: boolean }>(
  ({ theme, round, uppercase, isLoading }) => ({
    height: "40px",
    borderRadius: round
      ? theme.typography.pxToRem(39)
      : theme.typography.pxToRem(7),
    fontWeight: theme.fontWeight._700,
    fontSize: theme.typography.pxToRem(15),
    lineHeight: theme.typography.pxToRem(18),
    textTransform: uppercase ? "uppercase" : "unset",
    "&:disabled": {
      backgroundColor: theme.palette.custom.disable_gray,
      color: theme.palette.custom.disable_text_gray,
    },
    ...(isLoading && {
      pointerEvents: "none",
    }),
  })
);

export const StyledBasicButtonContent = styled("span", {
  shouldForwardProp: (prop) => prop !== "isLoading",
})<IBasicButtonContentProps>(({ isLoading }) => ({
  visibility: isLoading ? "hidden" : "visible",
}));

export const StyledBasicButtonLoader = styled("span", {
  shouldForwardProp: (prop) => prop !== "overlay",
})<IBasicButtonLoaderProps>(({ overlay }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ...(overlay && {
    position: "absolute",
    inset: 0,
  }),
}));
